import { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useLocation } from 'react-router-dom';

const Contact = () => {
  const location = useLocation()

  useEffect(()=>{
    const html = document.getElementsByTagName('html')[0];
    html.setAttribute('data-wf-page', '68603f7a056ff6f78f58cb16');
    html.setAttribute('data-wf-site', '68603f7a056ff6f78f58cab1');
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require('ix2').init();
    document.dispatchEvent(new Event('readystatechange'))
  },[])

  return (
    <>
      <div className="page-wrapper">
        <Navbar />
        <section class="section inner-banner">
          <div class="inner-banner-content">
            <div class="inner-banner-wrapper">
              <div class="container">
                <div class="inner-banner-typography">
                  <div class="inner-banner-subtitle-wrap">
                    <div class="inner-banner-subtitle">Contact</div>
                  </div>
                  <div class="inner-banner-title-wrapper">
                    <h1 class="inner-banner-title contact-us">Get in touch with us  for further information.</h1>
                  </div>
                </div>
              </div><img src="images/inner-20banner-20pluse-20icon.svg" loading="lazy" alt=""
                class="inner-banner-pluse-icon top-left" /><img src="images/inner-20banner-20pluse-20icon.svg"
                  loading="lazy" alt="" class="inner-banner-pluse-icon top-right" /><img
                src="images/inner-20banner-20pluse-20icon.svg" loading="lazy" alt=""
                class="inner-banner-pluse-icon bottom-left" /><img src="images/inner-20banner-20pluse-20icon.svg"
                  loading="lazy" alt="" class="inner-banner-pluse-icon bottom-right" />
            </div>
          </div>
        </section>
        <section class="section contact-us">
          <div class="container">
            <div data-w-id="cce02c8f-bf74-6eb9-db79-4a28a0499fb5" style={{ "opacity": "1" }} class="contact-us-wrapper">
              <div class="contact-us-form-block w-form">
                <form action="https://formspree.io/f/your-form-id" method="POST" id="email-form-2" name="email-form-2" data-name="Email Form 2" class="contact-us-form"
                  data-wf-page-id="68603f7a056ff6f78f58cb44" data-wf-element-id="668cf8f6-42ea-93b3-8347-b7eb10d2c9d7">
                  <div class="contact-us-form-wrapper">
                    <div class="contact-us-form-single"><label for="First-Name" class="contact-us-form-text-field">First
                      Name *</label><input class="contact-us-form-input-field w-input" maxlength="256" name="First-Name"
                        data-name="First Name" placeholder="John" type="text" id="First-Name" required="" /></div>
                    <div class="contact-us-form-single"><label for="Last-Name" class="contact-us-form-text-field">Last Name
                      *</label><input class="contact-us-form-input-field w-input" maxlength="256" name="Last-Name"
                        data-name="Last Name" placeholder="Smith" type="text" id="Last-Name" required="" /></div>
                  </div>
                  <div class="contact-us-form-wrapper">
                    <div class="contact-us-form-single"><label for="Your-Email" class="contact-us-form-text-field">Email
                      *</label><input class="contact-us-form-input-field w-input" maxlength="256" name="Your-Email"
                        data-name="Your Email" placeholder="Enter your email" type="email" id="Your-Email" required="" />
                    </div>
                    <div class="contact-us-form-single"><label for="Your-Phone-Number"
                      class="contact-us-form-text-field">Phone Number</label><input
                        class="contact-us-form-input-field w-input" maxlength="256" name="Your-Phone-Number"
                        data-name="Your Phone Number" placeholder="+1 234 5678" type="tel" id="Your-Phone-Number"
                        required="" /></div>
                  </div>
                  <div class="contact-us-textarea-wrapper"><label for="field"
                    class="contact-us-form-text-field">Message</label><textarea required=""
                      placeholder="Leave your message" maxlength="5000" id="field" name="field" data-name="Field"
                      class="contact-us-textarea w-input"></textarea></div>
                  <div className="navbar-button-wrapper">
                    <div className="primary-button-wrapper desktop"><a href="/JoinNow"
                      data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6" className="primary-button w-inline-block">
                      <div className="primary-button-border-wrap">
                        <div className="primary-button-wrap">
                          <div className="primary-button-text">Send a Message</div>
                          <div className="primary-button-hover-text">Send a Message</div>
                          <div className="primary-button-hover-bg"></div>
                        </div>
                      </div>
                      <div className="line-wrap">
                        <div className="primary-line-wrap _1">
                          <div className="line _1"></div>
                          <div className="line _2"></div>
                        </div>
                        <div className="primary-line-wrap _2">
                          <div className="line _3"></div>
                          <div className="line _4"></div>
                        </div>
                        <div className="primary-line-wrap _3">
                          <div className="line _5"></div>
                          <div className="line _6"></div>
                        </div>
                        <div className="primary-line-wrap _4">
                          <div className="line _7"></div>
                          <div className="line _8"></div>
                        </div>
                      </div>
                    </a></div>
                    <div className="menu-button w-nav-button">
                      <div data-is-ix2-target="1" className="hamburger-menu-icon" data-w-id="b58e0106-6be1-80f9-2e9e-29cc3a30b8aa"
                        data-animation-type="lottie" data-src="/images/hamburger-20menu.lottie" data-loop="0"
                        data-direction="1" data-autoplay="0" data-renderer="svg" data-duration="0" data-ix2-initial-state="0">
                        <span style={{ color: "#ffffff" }}>
                          <img src="/images/Hamburger_icon.png" alt="" style={{ width: "30%" }} />

                        </span>
                      </div>
                    </div>
                  </div>
                </form>
                <div class="w-form-done">
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div class="w-form-fail">
                  <div>Oops! Something went wrong while submitting the form.</div>
                </div>
              </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                class="contact-us-icon top-left" /><img src="images/features-20card-20shape-20top-20right.svg"
                  loading="lazy" alt="" class="contact-us-icon top-right" /><img
                src="images/features-20card-20shape-20bottom-20left.svg" loading="lazy" alt=""
                class="contact-us-icon bottom-left" /><img src="images/features-20card-20shape-20bottom-20right.svg"
                  loading="lazy" alt="" class="contact-us-icon bottom-right" />
            </div>
          </div>
        </section>
        <section data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d72e" class="section cta">
          <div class="container">
            <div class="cta-content">
              <div data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d731" class="cta-typography">
                <div class="cta-title-description">
                  <h2 class="cta-title">Embrace the future of Web3 and Blockchain.</h2>
                  <p class="cta-description-text">Highly scalable, fast and secure blockchain platform for distributed apps,
                    enterprise use cases.</p>
                </div>
                <div class="cta-button-wrapper">
                  <div class="primary-button-wrapper"><a href="/pricing" class="inner-button w-inline-block">
                    <div class="primary-button-border-wrap">
                      <div class="inner-button-wrap">
                        <div class="inner-button-text-wrap">
                          <div class="inner-button-text">Get started now</div>
                          <div class="inner-button-hover-text">Get started now</div>
                        </div>
                        <div class="inner-button-star-wrap"><img loading="lazy" src="images/inner-button-star-1.svg"
                          alt="" class="inner-button-star _1" /><img loading="lazy" src="images/inner-button-star-2.svg"
                            alt="" class="inner-button-star _2" /><img loading="lazy" src="images/inner-button-star-3.svg"
                              alt="" class="inner-button-star _3" /></div>
                        <div class="inner-button-hover-bg"></div>
                      </div>
                    </div>
                    <div class="line-wrap-inner">
                      <div class="inner-line-wrap _1">
                        <div class="line"></div>
                        <div class="line _2"></div>
                      </div>
                      <div class="inner-line-wrap _2">
                        <div class="line _3"></div>
                        <div class="line _4"></div>
                      </div>
                      <div class="inner-line-wrap _3">
                        <div class="line _5"></div>
                        <div class="line _6"></div>
                      </div>
                      <div class="inner-line-wrap _4">
                        <div class="line _7"></div>
                        <div class="line _8"></div>
                      </div>
                    </div>
                  </a></div>
                </div>
              </div><img src="images/features-20card-20shape-20top-20left.svg" loading="lazy" alt=""
                class="cta-top-left-element" /><img src="images/features-20card-20shape-20top-20right.svg" loading="lazy"
                  alt="" class="cta-top-right-element" /><img src="images/cta-20botton-20left-20element.svg" loading="lazy"
                    alt="" class="cta-bottom-left-element" /><img src="images/cta-20botton-20right-20element.svg" loading="lazy"
                      alt="" class="cta-bottom-right-element" /><img src="images/cta-20shape.webp" loading="lazy"
                        data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d752" sizes="(max-width: 537px) 100vw, 537px" alt=""
                        srcset="images/cta-2520shape-p-500.png 500w, images/cta-20shape.webp 537w" class="cta-shape" /><img
                src="images/cta-20elment1.webp" loading="lazy" data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d753" alt=""
                class="cta-elment-one" /><img src="images/cta-20elment2.webp" loading="lazy"
                  data-w-id="1c3f6ead-2444-a223-fec9-b2e0c543d754" alt="" class="cta-elment-two" />
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
}

export default Contact; 